if(typeof window !== 'undefined')
    $ = window.jQuery = window.$ = require('jquery');

var lib_core                  = require("lib-core");
var ui_extensions             = require("ui-extensions");
var cio_datamodel             = require("cio-datamodel");
var editor3d                  = require("editor-3d-light");
var editor2d                  = require("editor-2d");
var shared_extensions         = require("../shared/index.js");

var PackageSettingsController   = require("./extensions/packageSettings/packageSettingsController.js");
var PackageUploadController     = require("./extensions/modelUploader/modelUploadController.js");
var PackageViewerController     = require("./extensions/footprint3dViewer/packageFootprintViewerController.js");
//var ConnectEcadIoController = require("./extensions/connectEcadIo/connectEcadIoController.js");
var FootprintAdderController = require("./extensions/footprintAdder/footprintAddController.js");
var ModelAdderController = require("./extensions/modelAdder/modelAdderController.js");
var EcadioModelSelectorTrayController = require("./extensions/ecadioTray/ecadioModelSelectorTrayController.js");
var FootprintViewerController = require("./extensions/footprint2dViewer/footprintViewerController.js");
var AssetUpdaterController = require("./../shared/extensions/assetUpdater/assetUpdaterController.js");
var PackageGeneratorController = require("./extensions/packageGenerator/packageGeneratorController.js");
var PackageMasterController = require("./extensions/packageMasterView/packageMasterController.js");
var ExportModelController = require("./extensions/exportModel/exportModelController.js");
var UserSettingsController = require("./../shared/extensions/userSettings/userSettingsController.js");
var PackageGenerationManagerController = require("./extensions/packageGenerationManager/packageGenerationManagerController.js");
var PackageEditorAppSettings = require("./packageEditorAppSettings.js");
var GuiMode = require("./../shared/guiMode.js");

var PackageEditorApp = function(editorOptions, endpoints) {
    var self = this;

    // EDITOR MODE
    var editorMode = parseInt(editorOptions.mode);

    var settings = PackageEditorAppSettings(editorOptions, endpoints, editorMode);


    // CREATE CONFIG
    var config = PackageEditorApp.getConfig(settings.dataManagerConfig, settings.recorderConfig, settings.authConfig, endpoints, editorMode, editorOptions["hub"], editorOptions.environment, "Package", "Create a package with a footprint and 3D model.");

    // START EDITOR
    this['buildPromise'] = lib_core.Controller.buildApp(".editor", config);
    this['buildPromise']
        .catch(function(error) {
                logError("Package Editor App", error, logError.criticality.CRITICAL, "attempting to build extensions.");
        }).then(function(toplevelController) {
        self.toplevelController = toplevelController;
    });
};

PackageEditorApp.getConfig = function(dataManagerConfig, recorderConfig, authConfig, endpoints, editorMode, targetHub, environment, appLoadingName, appLoadingDescription){
    var config = {
        controller: ui_extensions.LoadingController,
        configuration : {
            icon: "https://123d-circuits-assets.s3.amazonaws.com/editorlogo-package.png",
            title: appLoadingName,
            description: appLoadingDescription,
            showOnlyLoadingBar: (editorMode <= GuiMode.INSPECT)
        },
        extensions: {
            "error_model": {
                controller: ui_extensions.ErrorMessageController
            },
            "user": {
                controller: lib_core.UserController,
                configuration : authConfig
            },
            "loading_watchdog": {
                controller: shared_extensions.LoadingWatchdogController,
                disabled: environment == 'local',
                configuration: {
                    timeout: 30*1000
                }
            },
            "app": {
                controller: lib_core.AppController,
                configuration : {
                    dataManagerConfig: dataManagerConfig,
                    recorderConfig: recorderConfig,
                    nodesToSkip: (editorMode <= GuiMode.EDIT)?["footprintInstances"]:[] // the switcher knows how to properly build this on selection.
                                                                // note that this collection (if used) must match the topmost collection in the switcher.
                },
                extensions: {
                    "master": {
                        controller: PackageMasterController,
                        configuration : {
                            logoImage: "https://123d-circuits-assets.s3.amazonaws.com/editorlogo-package.png",
                            logoLink: endpoints["mainSite"],
                            //readonly: (editorMode < lib_core.GuiMode.VIEW),
                            noNav: (editorMode <= GuiMode.VIEW),
                            wizardMode: (editorMode === GuiMode.LIMITED_EDIT)
                        },
                        extensions: {
                            "process_message": {
                                controller: ui_extensions.ProcessMessageController
                            },
                            // "connection_messages": {
                            //     disabled: (editorMode < GuiMode.LIMITED_EDIT),
                            //     controller: ui_extensions.ConnectionMessageController
                            // },
                            "package_version": {
                                disabled: (editorMode < GuiMode.LIMITED_EDIT),
                                controller: ui_extensions.SidebarController,
                                extensions: {
                                    "versions": {
                                        controller: ui_extensions.VersionsController,
                                        configuration: {
                                            preCheckBeforeVersionCreation: true
                                        }
                                    }
                                }
                            },
                            "package_generation_manager": {
                                disabled: (editorMode < GuiMode.INSPECT),
                                controller: PackageGenerationManagerController,
                            },

                            "package_3d_tab": {
                                name: "package_tab",
                                controller: ui_extensions.TabController,
                                configuration : {
                                    theme: "dark",
                                    mode: editorMode,
                                    button: {
                                        name: 'Package',
                                        title: 'Package Editor',
                                        style: {
                                            icon: 'icon-view-3dpackage.svg'
                                        }
                                    }
                                },
                                extensions: {
                                    "footprintSwitcher": {
                                        controller: ui_extensions.SwitcherController,
                                        configuration : {
                                            collection: ["footprintInstances"],
                                            theme: "dark",
                                            hidden: (editorMode <= GuiMode.LIMITED_EDIT),
                                            canNotEdit: (editorMode < GuiMode.EDIT)
                                        },
                                        extensions: {
                                            "editor": {
                                                controller: editor3d.Editor3dController,
                                                configuration : {
                                                    mode: editorMode,
                                                    theme: "dark",
                                                    clearColor: 0x1B1B1B,
                                                    disableMouse: (editorMode <= GuiMode.RENDER),
                                                    disableKeys:(editorMode <= GuiMode.RENDER),
                                                    canNotSelect: (editorMode <= GuiMode.INSPECT),
                                                    lights: [
                                                        {
                                                            type: "directional",
                                                            color: 0xDADADA,
                                                            position: [0, 5, 10],
                                                            intensity: 0.4
                                                        },
                                                        {
                                                            type: "directional",
                                                            color: 0xDADADA,
                                                            position: [0, 5, -10],
                                                            intensity: 0.4
                                                        },
                                                        {
                                                            type: "directional",
                                                            color: 0xE8E670,
                                                            position: [5, 0, 5],
                                                            intensity: 0.6
                                                        },
                                                        {
                                                            type: "directional",
                                                            color: 0xE8E670,
                                                            position: [-5, 0, 5],
                                                            intensity: 0.6
                                                        },
                                                        {
                                                            type: "directional",
                                                            color: 0x775533,
                                                            position: [5, 0, 1],
                                                            intensity: 0.2
                                                        },
                                                        {
                                                            type: "directional",
                                                            color: 0x775533,
                                                            position: [-5, 0, 1],
                                                            intensity: 0.2
                                                        },
                                                        {
                                                            type: "ambient",
                                                            color: 0x777799,
                                                            intensity: 1
                                                        }

                                                    ]
                                                },
                                                extensions: {
                                                    // 3D EXTENSIONS
                                                    "camera": {
                                                        //disabled: (editorMode === lib_core.GuiMode.RENDER),
                                                        controller: editor3d.Camera3dController,
                                                        configuration : {
                                                            buttons: (editorMode > GuiMode.RENDER),
                                                            fov: 60,
                                                            near: 0.1,
                                                            far: 2000,
                                                            rotateSpeed: 1/2000,
                                                            zoomSpeed: 1.048
                                                        }
                                                    },


                                                    "selection": {
                                                        //disabled: (editorMode === lib_core.GuiMode.RENDER),
                                                        controller: editor3d.Selection3dController,
                                                        extensions: {
                                                            "inspector": {
                                                                disabled: (editorMode <= GuiMode.VIEW),
                                                                controller: ui_extensions.InspectorController,
                                                                configuration : {
                                                                    read_only: (editorMode < GuiMode.LIMITED_EDIT),
                                                                    draggable: true,
                                                                    //multiSelectHide: false
                                                                    location: "top right",
                                                                },
                                                                extensions: {
                                                                    "dragging": {
                                                                        controller: ui_extensions.DraggingController
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    },

                                                    "planeMovement": {  //  needs camera and selection
                                                        disabled: (editorMode < GuiMode.LIMITED_EDIT),
                                                        controller: editor3d.Plane3dMovementController
                                                    },

                                                    "packageViewer": {
                                                        controller: PackageViewerController,
                                                        configuration: {
                                                            resetCameraWithSwitcher: false,
                                                            autoSelect: true,
                                                            footprintOpen    : (editorMode >= GuiMode.EDIT),
                                                            versionEdit      : (editorMode >= GuiMode.EDIT),
                                                            placementEdit    : (editorMode >= GuiMode.LIMITED_EDIT),
                                                            cameraButtons    : (editorMode >= GuiMode.VIEW),
                                                            placementButtons : (editorMode >= GuiMode.LIMITED_EDIT),
                                                            hideGrid         : (editorMode <= GuiMode.RENDER),
                                                            hoverTransparent : (editorMode <= GuiMode.VIEW),
                                                            targetHub: targetHub,
                                                            color: 0x898989,
                                                            specular: 0x222222,
                                                            shininess: 50,
                                                            handles: [ "moveX", "moveY", "moveVertical", "rotationGlobalX", "rotationGlobalY", "rotationGlobalZ"],
                                                            pads: {
                                                                color: 0xffe34d,
                                                                specular: 0x666622,
                                                                shininess: 70,
                                                                extrusion: 0.035
                                                            },
                                                            silkscreen: {
                                                                color: 0xffffff,
                                                                specular: 0xffffff,
                                                                shininess: 0,
                                                                extrusion: 0.045
                                                            },
                                                            board : {
                                                                color: 0x006400,
                                                                gridColor: 0x629932,
                                                                specular: 0x003409,
                                                                shininess: 10
                                                            }
                                                        }
                                                     },
  
                                                    "packageUploader": {
                                                        disabled: (editorMode < GuiMode.LIMITED_EDIT),
                                                        controller: PackageUploadController,
                                                        configuration : {
                                                            height: 300,
                                                            maxFilesAtOnce: (editorMode < GuiMode.EDIT)?10:300,
                                                            button: {
                                                                name: 'Upload',
                                                                title: 'Upload STEP/F3D',
                                                                style: {
                                                                    icon: 'icon-import.svg'
                                                                },
                                                                id: 'upload_file'
                                                            }
                                                        }
                                                    },


                                                    "GrotationHandleX": {
                                                        disabled: (editorMode < GuiMode.LIMITED_EDIT),
                                                        controller: editor3d.GlobalXRotationController,
                                                        configuration: {
                                                            color: 0xff0000,
                                                            opacity: 0.6,
                                                            size: 1.5,
                                                            radiusMultInc: 0.09,
                                                            extraRadius: 0
                                                        }
                                                    },
                                                    "GrotationHandleY": {
                                                        disabled: (editorMode < GuiMode.LIMITED_EDIT),
                                                        controller: editor3d.GlobalYRotationController,
                                                        configuration: {
                                                            color: 0x00ff00,
                                                            opacity: 0.6,
                                                            size: 1.5,
                                                            radiusMultInc: 0.09,
                                                            extraRadius: 0
                                                        }
                                                    },
                                                    "GrotationHandleZ": {
                                                        disabled: (editorMode < GuiMode.LIMITED_EDIT),
                                                        controller: editor3d.GlobalZRotationController,
                                                        configuration: {
                                                            color: 0x0000ff,
                                                            opacity: 0.6,
                                                            size: 1.5,
                                                            radiusMultInc: 0.09,
                                                            extraRadius: 0
                                                        }
                                                    },


                                                    "verticalHandle": {
                                                        disabled: (editorMode < GuiMode.LIMITED_EDIT),
                                                        controller: editor3d.VerticalHandleController,
                                                        configuration: {
                                                            color: 0x0000ff,
                                                            opacity: 0.3,
                                                            size: 1.5,
                                                            radiusMultInc: 0.09,
                                                            extraRadius: 0
                                                        }
                                                    },
                                                    "XMoveHandle": {
                                                        disabled: (editorMode < GuiMode.LIMITED_EDIT),
                                                        controller: editor3d.XHandleController,
                                                        configuration: {
                                                            color: 0xff0000,
                                                            opacity: 0.3,
                                                            size: 1.5,
                                                            radiusMultInc: 0.09,
                                                            extraRadius: 0
                                                        }
                                                    },
                                                    "YMoveHandle": {
                                                        disabled: (editorMode < GuiMode.LIMITED_EDIT),
                                                        controller: editor3d.YHandleController,
                                                        configuration: {
                                                            color: 0x00ff00,
                                                            opacity: 0.3,
                                                            size: 1.5,
                                                            radiusMultInc: 0.09,
                                                            extraRadius: 0
                                                        }
                                                    },

                                                    // OTHER
                                                    "undoRedo": {
                                                        disabled: (editorMode < GuiMode.LIMITED_EDIT),
                                                        controller: editor2d.UndoRedoController
                                                    },

                                                    "dragDrop": {
                                                        disabled: (editorMode < GuiMode.LIMITED_EDIT),
                                                        controller: editor3d.DragDropController
                                                    },

                                                    "package_generator": {
                                                        disabled: (editorMode < GuiMode.INSPECT),
                                                        controller: PackageGeneratorController,
                                                        configuration : {
                                                            theme: "dark",
                                                            urls: endpoints,
                                                            targetHub: targetHub,
                                                            button: {
                                                                style: {
                                                                    icon: 'icon-generator.svg'
                                                                },
                                                                wizardMode: {
                                                                    name: 'Package Generators'
                                                                },
                                                                nonWizardMode: {
                                                                    name: 'Generate',
                                                                    title: 'Generate Model',
                                                                },
                                                                hidden: (editorMode <= GuiMode.INSPECT)
                                                            },
                                                            read_only: (editorMode < GuiMode.LIMITED_EDIT),
                                                            disableIpcForking: dataManagerConfig.document_options.disableIpcForking,
                                                            sidebar: {
                                                                position: 'left',
                                                                width: '329px',
                                                                theme: 'dark',
                                                                wizardMode: {
                                                                    title: 'Package Generators'
                                                                },
                                                                nonWizardMode: {
                                                                    title: 'Model Generators'
                                                                }
                                                            }
                                                        }
                                                    },

                                                   "tray": {
                                                        disabled: (editorMode < GuiMode.EDIT),
                                                        controller: ui_extensions.TrayController,
                                                        configuration : {
                                                            button: {
                                                                name: 'Add Footprint',
                                                                title: 'Add Footprint',
                                                                style: {
                                                                    icon: 'icon-plus.svg'
                                                                }
                                                            }
                                                        },
                                                        extensions: {
                                                            "package_tabs": {
                                                                controller: ui_extensions.TrayTabsController,
                                                                configuration : {
                                                                    tab_buttons: {
                                                                        create_footprint_button: {
                                                                            name: 'Create new footprint',
                                                                            description: 'Create new footprint',
                                                                            id: 'create_footprint'
                                                                        }
                                                                    },
                                                                    search_box: {
                                                                        title: 'Search for footprint',
                                                                        id: 'search_package',
                                                                        enableFiltering: true
                                                                    },
                                                                    defaultTab: "footprints",
                                                                    assetType: "footprint"
                                                                },
                                                                extensions: {
                                                                    "footprints": {
                                                                        controller: ui_extensions.TrayAssetSearchTabController,
                                                                        configuration : {
                                                                            title: "Public Footprints",
                                                                            template: "grid",
                                                                            alternative_template: "list",
                                                                            url: endpoints["footprintEditor"],
                                                                            overlay: true,
                                                                            showPublicAssets: true,
                                                                            overlayGroup: "dimensions",
                                                                            viewConfig: { // TODO  build based on properties file
                                                                                columns: [
                                                                                {   name: 'Name',
                                                                                    key: 'name',
                                                                                    enableSorting: true,
                                                                                    isLink: true
                                                                                },

                                                                                {   name: 'Pins',
                                                                                    key: 'pins',
                                                                                    enableSorting: true,
                                                                                    location: 'left',
                                                                                    isProperty: true
                                                                                },
                                                                                {
                                                                                    name: 'Pitch',
                                                                                    key: 'pitch',
                                                                                    enableSorting: true,
                                                                                    location: 'left',
                                                                                    isProperty: true
                                                                                },
                                                                                {
                                                                                    name: 'Body Length',
                                                                                    key: 'body_length',
                                                                                    enableSorting: true,
                                                                                    location: 'left',
                                                                                    isProperty: true
                                                                                },
                                                                                {
                                                                                    name: 'Body Width',
                                                                                    key: 'body_width',
                                                                                    enableSorting: true,
                                                                                    location: 'left',
                                                                                    isProperty: true
                                                                                },

                                                                                {
                                                                                    name: 'Height',
                                                                                    key: 'height',
                                                                                    enableSorting: true,
                                                                                    location: 'left',
                                                                                    isProperty: true
                                                                                },
                                                                                {
                                                                                    name: 'Lead Span',
                                                                                    key: 'lead_span',
                                                                                    enableSorting: true,
                                                                                    location: 'left',
                                                                                    isProperty: true
                                                                                },
                                                                                {
                                                                                    name: 'Lead Span 2',
                                                                                    key: 'lead_span2',
                                                                                    enableSorting: true,
                                                                                    location: 'left',
                                                                                    isProperty: true
                                                                                },
                                                                                {
                                                                                    name: 'Pitch 2',
                                                                                    key: 'pitch2',
                                                                                    enableSorting: true,
                                                                                    location: 'left',
                                                                                    isProperty: true
                                                                                } ],

                                                                                enableAssetDetails: true,
                                                                                enableSorting: true,
                                                                                enableLeftOverflow: true
                                                                            }
                                                                        }
                                                                    },
                                                                    "my_footprints": {
                                                                        controller: ui_extensions.TrayAssetSearchTabController,
                                                                        configuration : {
                                                                            title: "My Footprints",
                                                                            template: "grid",
                                                                            alternative_template: "list",
                                                                            showHubAssets: true,
                                                                            url: endpoints["footprintEditor"],
                                                                            overlay: true,
                                                                            overlayGroup: "dimensions",
                                                                            viewConfig: { // TODO  build based on properties file
                                                                                columns: [
                                                                                {   name: 'Name',
                                                                                    key: 'name',
                                                                                    enableSorting: true,
                                                                                    isLink: true
                                                                                },

                                                                                {   name: 'Pins',
                                                                                    key: 'pins',
                                                                                    enableSorting: true,
                                                                                    location: 'left',
                                                                                    isProperty: true
                                                                                },
                                                                                {
                                                                                    name: 'Pitch',
                                                                                    key: 'pitch',
                                                                                    enableSorting: true,
                                                                                    location: 'left',
                                                                                    isProperty: true
                                                                                },
                                                                                {
                                                                                    name: 'Body Length',
                                                                                    key: 'body_length',
                                                                                    enableSorting: true,
                                                                                    location: 'left',
                                                                                    isProperty: true
                                                                                },
                                                                                {
                                                                                    name: 'Body Width',
                                                                                    key: 'body_width',
                                                                                    enableSorting: true,
                                                                                    location: 'left',
                                                                                    isProperty: true
                                                                                },

                                                                                {
                                                                                    name: 'Height',
                                                                                    key: 'height',
                                                                                    enableSorting: true,
                                                                                    location: 'left',
                                                                                    isProperty: true
                                                                                },
                                                                                {
                                                                                    name: 'Lead Span',
                                                                                    key: 'lead_span',
                                                                                    enableSorting: true,
                                                                                    location: 'left',
                                                                                    isProperty: true
                                                                                },
                                                                                {
                                                                                    name: 'Lead Span 2',
                                                                                    key: 'lead_span2',
                                                                                    enableSorting: true,
                                                                                    location: 'left',
                                                                                    isProperty: true
                                                                                },
                                                                                {
                                                                                    name: 'Pitch 2',
                                                                                    key: 'pitch2',
                                                                                    enableSorting: true,
                                                                                    location: 'left',
                                                                                    isProperty: true
                                                                                } ],

                                                                                enableAssetDetails: true,
                                                                                enableSorting: true,
                                                                                enableLeftOverflow: true
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    },

                                                    "3dmodel_tray": {
                                                        disabled: (editorMode < GuiMode.LIMITED_EDIT),
                                                        controller: ui_extensions.TrayController,
                                                        configuration : {
                                                            button: {
                                                                name: "Add",
                                                                title: "Add Model",
                                                                style: {
                                                                    icon: "icon-plus.svg"
                                                                }
                                                            }

                                                        },
                                                        extensions: {
                                                            "3dmodel_tab": {
                                                                controller: ui_extensions.TrayTabsController,
                                                                configuration : {
                                                                    tab_buttons: {
                                                                        upload_step_button: {
                                                                            name: 'Upload STEP',
                                                                            description: 'Create new 3D Model Data',
                                                                            id: 'upload_step'
                                                                        }
                                                                    },
                                                                    search_box: {
                                                                        title: 'Search for models',
                                                                        id: 'search_models'
                                                                    },
                                                                    defaultTab: 'my_models',
                                                                    assetType: "3dmodel"
                                                                },
                                                                extensions: {
                                                                    "all_models": {
                                                                        controller: ui_extensions.TrayAssetSearchTabController,
                                                                        configuration : {
                                                                            title: "Public Models",
                                                                            template: "grid",
                                                                            alternative_template: "list",
                                                                            //owned_only: false,
                                                                            showPublicAssets: true,
                                                                            isUnversioned: true,
                                                                            overlay: true,
                                                                            viewConfig: {
                                                                                columns: [
                                                                                {   name: 'Name',
                                                                                    key: 'name',
                                                                                    enableSorting: true,
                                                                                    isLink: true
                                                                                }, {
                                                                                    name: 'Folder',
                                                                                    key: 'hub',
                                                                                    enableSorting: true,
                                                                                    location: 'left',
                                                                                },
                                                                                {
                                                                                    name: 'Description',
                                                                                    key: 'description',
                                                                                    enableSorting: false,
                                                                                    isLink: false,
                                                                                    location: 'left',
                                                                                    description: true,
                                                                                }],

                                                                                enableAssetDetails: true,
                                                                                enableSorting: true,
                                                                                enableLeftOverflow: true
                                                                            }
                                                                        }
                                                                    },
                                                                    "my_models": {
                                                                        controller: ui_extensions.TrayAssetSearchTabController,
                                                                        configuration : {
                                                                            title: "My Models",
                                                                            template: "grid",
                                                                            alternative_template: "list",
                                                                            showHubAssets: true,
                                                                            isUnversioned: true,
                                                                            viewConfig: {
                                                                                columns: [
                                                                                {   name: 'Name',
                                                                                    key: 'name',
                                                                                    enableSorting: true,
                                                                                    isLink: true
                                                                                }, {
                                                                                    name: 'Folder',
                                                                                    key: 'hub',
                                                                                    enableSorting: true,
                                                                                    location: 'left',
                                                                                },
                                                                                {
                                                                                    name: 'Description',
                                                                                    key: 'description',
                                                                                    enableSorting: false,
                                                                                    isLink: false,
                                                                                    location: 'left',
                                                                                    description: true,
                                                                                }],
                                                                                enableAssetDetails: true,
                                                                                enableSorting: true,
                                                                                enableLeftOverflow: true
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    },

                                                    "3dmodel_adder": {
                                                        disabled: (editorMode < GuiMode.LIMITED_EDIT),
                                                        controller: ModelAdderController,
                                                        configuration : {
                                                            collection: ["model3d"]
                                                        }
                                                    },

                                                    "footprint_adder": {
                                                        disabled: (editorMode < GuiMode.EDIT),
                                                        controller: FootprintAdderController,
                                                        configuration : {
                                                            collection: ["footprintInstances"],
                                                            url: endpoints["footprintEditor"]
                                                        }
                                                    },
                                                    "footprint_updater": {
                                                        disabled: (editorMode < GuiMode.EDIT),
                                                        controller: AssetUpdaterController,
                                                        configuration : {
                                                            collection: ["footprintInstances"],
                                                            url: endpoints["footprintEditor"]
                                                        }
                                                    },
                                                    "footprint_creater": {
                                                        disabled: (editorMode < GuiMode.EDIT),
                                                        controller: ui_extensions.WindowOpenerController,
                                                        configuration : {
                                                            button_id: 'create_footprint',
                                                            url: endpoints["footprintEditor"]
                                                        }
                                                    },

                                                    "packageExporter": {
                                                        disabled: (editorMode <= GuiMode.VIEW),
                                                        controller: ExportModelController,
                                                        configuration : {
                                                            //height: 300,
                                                            button: {
                                                                name: 'Export',
                                                                title: 'Export Model',
                                                                style: {
                                                                    icon: 'icon-export.svg'
                                                                },
                                                                id: 'export_model',
                                                                sortOrder: 0
                                                            }
                                                        }
                                                    },

                                                    "options": {
                                                        disabled: (editorMode < GuiMode.VIEW),
                                                        controller: ui_extensions.OptionsController,
                                                        configuration : {
                                                            draggable: true,
                                                            location: "top left",
                                                            title: "Options",
                                                            icon: "icon-drawingaids.svg"
                                                        }
                                                    },

                                                    "userSettings": {
                                                        controller: UserSettingsController
                                                    },

                                                    // "connectEcadIo": {
                                                    //     disabled: (editorMode < GuiMode.EDIT),
                                                    //     controller: ConnectEcadIoController,
                                                    //     configuration : {
                                                    //         button: {
                                                    //             name: 'Select EcadIO',
                                                    //             title: 'Select EcadIO',
                                                    //             style: {
                                                    //                 icon: 'icon-link-external.svg' //TODO
                                                    //             },
                                                    //             id: 'connect_ecadio'
                                                    //         },
                                                    //         height: 300
                                                    //     }
                                                    // },



                                                    // Not sure what this is?
                                                    // update_tray: {
                                                    //     controller: ui_extensions.TrayController,
                                                    //     configuration : {
                                                    //         button: {
                                                    //             name: 'Update Footprints',
                                                    //             title: 'Update Footprints',
                                                    //             style: {
                                                    //                 icon: 'icon-plus.svg'
                                                    //             }
                                                    //         }
                                                    //     },
                                                    //     extensions: {
                                                    //         tabs: {
                                                    //             controller: ui_extensions.TrayTabsController,
                                                    //             configuration : {
                                                    //                 search_box: {
                                                    //                     title: 'Search for update',
                                                    //                     id: 'search_footprint'
                                                    //                 }
                                                    //             },
                                                    //             extensions: {
                                                    //                 updates: {
                                                    //                     controller: ui_extensions.TrayAssetUpdateTabController,
                                                    //                     configuration : {
                                                    //                         title: "Updates",
                                                    //                         template: "list",
                                                    //                         alternative_template: "grid",
                                                    //                         type: "footprints",
                                                    //                         collection: ["footprintInstances"]
                                                    //                     }
                                                    //                 }
                                                    //             }
                                                    //         }
                                                    //     }
                                                    // },
                                                }
                                            }
                                        }
                                    }
                                }
                            },
                            "settings_tab": {
                                disabled: (editorMode < GuiMode.INSPECT),
                                name: "settings_tab",
                                controller: ui_extensions.TabController,
                                configuration : {
                                    button: {
                                        name: 'Settings',
                                        title: 'Settings',
                                        style: {
                                            icon: 'icon-settings.svg'
                                        }
                                    }
                                },
                                extensions: {
                                    "settingsForm": {
                                        controller: PackageSettingsController,
                                        configuration : {
                                            nameReadOnly: (editorMode < GuiMode.EDIT),
                                            summaryReadOnly: (editorMode < GuiMode.EDIT),
                                            descriptionReadOnly: (editorMode < GuiMode.EDIT),
                                            propertiesReadOnly: (editorMode < GuiMode.LIMITED_EDIT),
                                            data: []
                                        }
                                    }
                                }
                            },
                            "avatar_tab": {
                                disabled: (editorMode <= GuiMode.VIEW),
                                name: "avatar_tab",
                                controller: ui_extensions.AvatarController,
                                configuration : {
                                    userUrl: endpoints['accounts']
                                }
                            }
                        }
                    }
                }
            }
        }
    };
    return config;
};

module.exports = PackageEditorApp;

if(typeof window !== 'undefined') {
    window["PackageEditorApp"] = PackageEditorApp;
}
